import useUsuarioStore from "../stores/UsuarioStore";
import ERP from "../ERP.mjs";
import Schema from "../Schema.mjs";
import View from "../View.mjs";
import OrdemDeServicoItemService from "./OrdemDeServicoItemService";
import UtilArray from "../../../utils/UtilArray.mjs";
import UtilDateTime from "@/utils/UtilDateTime";

export default {

    async tentaEncerrarCotacoes(){

        let cotacoes;

        try{

            //==================================================================//
            //======================= Encerra a Cotação ========================//
            //==================================================================//
            // Apenas se todos os Itens da Cotação foram Encerrados ou Finalizados.

            cotacoes = await ERP.getManyWithView(View.COTACAO_PEDIDO_DE_COMPRA_ESTA_ENCERRADA)
            if(cotacoes.status != 200){
                console.log("Tenta Obter as Cotações que devem ser Encerradas Falhou");
                throw cotacoes;
            }

            cotacoes = cotacoes.data.reduce((acc,cotacao)=>{

                if(cotacao.situacao == "Encerrada"){
                    acc.push(cotacao.id);
                }
                return acc;

            },[]);

            if(!UtilArray.isEmpty(cotacoes)){

                cotacoes = await this.alterarStatus("Encerrada",cotacoes);
                if(cotacoes.status != 200){
                    console.log('Tenta Alterar o Status das Cotações que devem ser Encerradas para "Encerrada" Falhou');
                    throw cotacoes;
                }

            }

        }catch(e){

            console.log(e);
            return cotacoes;

        }

        let response = {
            data:{
                cotacoes: cotacoes?.data || [],
            },
            statusText: "",
            status: 200
        };

        return response;

    },

    async alterarStatus(statusNovo, cotacoes = []){

        try{

            cotacoes = cotacoes.map((cotacao) => {

                return{
                    id: cotacao,
                    status: statusNovo,
                }
    
            });

            cotacoes = await ERP.patchMany(Schema.COTACAO_DE_PEDIDO_DE_COMPRA, cotacoes);
            if(cotacoes.status != 200){
                throw cotacoes;
            }

            console.log(cotacoes);

        }catch(e){

            console.log(e);
            return cotacoes;

        }

        return cotacoes;

    },

    async criarCotacao(requisicoesDeCompra = [], comprador){

        let cotacao;
        let usuarioStore = useUsuarioStore();

        try{

            //==================================================================//
            //==================== Altera Ordens de Serviço ====================//
            //==================================================================//

            requisicoesDeCompra = await ERP.getManyById(Schema.REQUISICAO_DE_COMPRA,requisicoesDeCompra);
            if(requisicoesDeCompra.status != 200){
                throw requisicoesDeCompra;
            }

            let ordensDeServicoItens = requisicoesDeCompra.data.map(({ordemDeServicoItem})=>{
                
                return {
                    id: ordemDeServicoItem,
                    dataEntrega: "",
                    fornecedor: "",
                    fornecedorMaterialFornecido: "",
                    quantidadeCompra: 0,
                    quantidadeParaReceber: 0,
                    unidadeCompra: null,
                    precoUnitarioComImpostos: 0,
                    precoUnitarioComImpostosPorcentagemDoDesconto: 0,
                    precoUnitarioComImpostosComDesconto: 0,
                    precoTotalComImpostos: 0,
                    temISS: true,
                    porcentagemISS: 0,
                    valorPIS: 0,
                    valorCOFINS: 0,
                    temICMS: true,
                    porcentagemICMS: 0,
                    valorICMS: 0,
                    temIPI: true,
                    porcentagemIPI: 0,
                    valorIPI: 0,
                    precoTotalSemImpostosComIPI: 0,
                    precoTotalComImpostosComIPI: 0,
                    status: "CT"
                }
             
            });

            ordensDeServicoItens = await OrdemDeServicoItemService.alterarItens(ordensDeServicoItens);
            if(ordensDeServicoItens.status != 200){
                throw ordensDeServicoItens;
            }

            //==================================================================//
            //======================= Cria Cotação Itens =======================//
            //==================================================================//

            let cotacaoItens = requisicoesDeCompra.data.map((requisicaoDeCompra) => {

                return{
                    status: "Em Desenvolvimento",
                    valido: "Não",
                    requisicaoDeCompra: requisicaoDeCompra.id,
                    ordemDeServicoItem: requisicaoDeCompra.ordemDeServicoItem,
                }
        
            });

            cotacaoItens = await ERP.postMany(Schema.COTACAO_DE_PEDIDO_DE_COMPRA_ITENS, cotacaoItens);
            if(cotacaoItens.status != 200){
                throw cotacaoItens;
            }
            
            console.log(cotacaoItens);

            //==================================================================//
            //========================== Cria Cotação ==========================//
            //==================================================================//

            let cotacaoItensIDs = cotacaoItens.data.map(({id})=>id);

            cotacao = {
                status: "Em Desenvolvimento",
                comprador: comprador.id,
                itens: cotacaoItensIDs,
                dataCriacao: UtilDateTime.todayUTC(),
                owners: UtilArray.unique(["23e308ed-4f67-4394-9a77-7228d2992dc3", usuarioStore.usuario.id])
            }

            cotacao = await ERP.postOne(Schema.COTACAO_DE_PEDIDO_DE_COMPRA, cotacao);
            if(cotacao.status != 200){
                throw cotacao;
            }

            console.log(cotacao);

        }catch(e){

            console.log(e);
            return cotacao;

        }

        return cotacao;

    },

}